// src/app/services/ailike-jobs.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http'; // Make sure HttpParams is imported
import { Observable } from 'rxjs';
import { Job } from '../Models/job.model';

@Injectable({
  providedIn: 'root'
})
export class JobToJobListService {
  constructor(private http: HttpClient) {}

  getJobs(input: any): Observable<Job[]> {
    return this.http.post<Job[]>('/TgNewUI/Search/Ajax/AILikeJobs', input);
  }
  fetchJobs(input: any, widgetType: string = ''): Observable<Job[]> {
   const jobListUrl: string = widgetType === 'profilematch'
  ? '/TgNewUI/Search/Ajax/AIProfileSMartJobs'
  : '/TgNewUI/Search/Ajax/AILikeJobs';
    return this.http.post<Job[]>(jobListUrl, input);
  }

  getResumeToJDScore(input: any): Observable<string> {
   const url =
    `/Rchilliservice/api/RchilliParseAndIndex/ResumetoJD` +
    `?partnerId=${encodeURIComponent(input.partnerId)}` +
    `&profileId=${encodeURIComponent(input.profileId)}` +
    `&jobId=${encodeURIComponent(input.jobId)}`;

  return this.http.post<string>(url, {});
  }
}
